var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"scroll",staticStyle:{"width":"100%","height":"100%","position":"relative","overflow":"hidden","display":"flex","align-items":"center","justify-content":"center","white-space":"nowrap"}},[_c('span',{ref:"ele1",style:(_vm.style1)},[_vm._v(_vm._s(_vm.data))]),_c('span',{ref:"ele2",style:(_vm.style2)},[_vm._v(_vm._s(_vm.data))])])
}
var staticRenderFns = []

export { render, staticRenderFns }